import type { User } from "firebase/auth";

export async function startCheckout(priceId: string, user: User | null): Promise<void> {
  if (!user) throw new Error("User must be logged in to subscribe");
  if (!priceId) throw new Error("Price ID is required");

  const res = await fetch("/.netlify/functions/create-checkout-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      priceId,
      userEmail: user.email,
      userId: user.uid,
    }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Checkout failed");

  if (data.url) {
    window.location.href = data.url;
  } else {
    throw new Error("No checkout URL returned");
  }
}

export async function openPortal(customerId: string, returnUrl?: string): Promise<void> {
  if (!customerId) throw new Error("customerId is required");

  const res = await fetch("/.netlify/functions/create-portal-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ customerId, returnUrl }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Portal failed");

  if (data.url) {
    window.location.href = data.url;
  } else {
    throw new Error("No portal URL returned");
  }
}
